const valetOrder = resolve => require(['@/pages/valetOrder/index'], resolve);
const valetOrderNext = resolve => require(['@/pages/valetOrder/nextEdit'], resolve);
export default [
  {
    path: "/valetOrder",
    name: "代客下单",
    component: valetOrder
  },
  {
    path: "/valetOrderNext",
    name: "代客下单",
    component: valetOrderNext
  }
]
